import {createSlice} from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/member-level/MemberLevelUIHelpers";

const initialCustomersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  memberLevelForEdit: undefined,
  lastError: null,
  filters: initialFilter
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const memberLevelSlice = createSlice({
  name: "memberLevels",
  initialState: initialCustomersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerById
    memberLevelFetched: (state, action) => {
      state.actionsLoading = false;
      state.memberLevelForEdit = action.payload.memberLevelForEdit;
      state.error = null;
    },
    // findCustomers
    memberLevelsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // createCustomer
    memberLevelCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.memberLevel);
    },
    // updateCustomer
    memberLevelUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.memberLevel.id) {
          return action.payload.memberLevel;
        }
        return entity;
      });
    },
    memberLevelFilter: (state, action) => {
      state.listLoading = false
      state.error = null
      state.filters = action.payload
    }
  }
});
